import PropTypes from 'prop-types';

import Advanced from './Advanced';
import Simple from './Simple';

const Recurring = ({ campaign, periodicities }) => {
  switch (campaign.recurring_mode) {
    case 'advanced_recurring':
      return (
        <Advanced
          periodicities={periodicities}
          currency={campaign.currency.code}
        />
      );
    case 'simple_recurring':
      return <Simple />;
    case 'no_recurring':
    default:
      return null;
  }
};

Recurring.propTypes = {
  campaign: PropTypes.object.isRequired,
  periodicities: PropTypes.array.isRequired,
};

export default Recurring;
